import { gql } from '@apollo/client';

export const UPDATE_GROUND_WATER_MONITOR = gql`
    mutation UpdateGroundWaterMonitor($id: Guid!, $input: UpdateGroundWaterMonitor!) {
        facility {
            process {
                updateGroundWaterMonitor(id: $id, input: $input) {
                    id
                }
            }
        }
    }
`;
